import { HttpError } from './http-error';

function authBaseUrl(): string {
  if (typeof window === 'undefined' || !window.X_AUTH_API_URL) {
    throw new Error('Auth API URL is not available');
  }
  return window.X_AUTH_API_URL.replace(/\/$/, '');
}

async function parseBody(response: Response): Promise<unknown> {
  const text = await response.text();
  if (!text) return undefined;

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

async function authRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${authBaseUrl()}${path}`, {
    ...init,
    credentials: 'include',
  });
  const data = await parseBody(response);

  if (!response.ok) {
    throw new HttpError(response.status, data);
  }

  return data as T;
}

export async function loginWithPassword(username: string, password: string): Promise<void> {
  await authRequest('/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ username, password }),
  });
}

export async function logoutTenantRegistry(): Promise<void> {
  await authRequest('/logout', { method: 'POST' });
}

export async function resetPassword(payload: {
  token: string | null;
  email: string | null;
  new_password: string;
}): Promise<void> {
  await authRequest('/reset-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function refreshTenantRegistryToken(): Promise<string | null> {
  try {
    const data = await authRequest<{ access_token?: string }>('/refresh', { method: 'GET' });
    return typeof data?.access_token === 'string' ? data.access_token : null;
  } catch (error) {
    if (error instanceof HttpError) {
      console.debug('refresh token failed: ', error.status, error.data);
      return null;
    }
    throw error;
  }
}
